import isHotkey from 'is-hotkey';
import {Editor, Transforms} from 'slate';
import {SELECTABLE_ELEMENT_TYPES} from '../constants';
import makeParagraph from '../factory/makeParagraph';

function onDeleteOrShiftArrowBeforeSelectableElement (editor, event, selectionMeta, {selectElements}) {
  const {
    isSelectionAtEndOfElement,
    isSelectionCollapsed,
    selectionStart,
    selectionStartElement,
    selectionStartElementPath,
    selectionStartAncestors,
    selectionStartTextNode,
  } = selectionMeta;

  if (
    (
      event.key !== 'Delete' &&
      !isHotkey('shift+right')(event) &&
      !isHotkey('shift+down')(event)
    ) ||
    !selectionStart ||
    !isSelectionAtEndOfElement ||
    selectionStartAncestors.find((n) => n.type === 'help-block-content')
  ) {
    return false;
  }

  const selectionStartContainerPath = selectionStartAncestors.find((n) => n.type === 'process-step')
    ? selectionStart.path.slice(0, 5)
    : selectionStart.path.slice(0, 1);
  const [selectableElement, selectableElementPath] = Editor.next(editor, {at: selectionStartContainerPath}) || [undefined, undefined];

  if (
    !selectableElement ||
    !SELECTABLE_ELEMENT_TYPES.includes(selectableElement.type)
  ) {
    return false;
  }

  event.preventDefault();

  if (
    event.key === 'Delete' &&
    [
      'heading1',
      'heading2',
      'heading3',
      'heading4',
      'paragraph',
    ].includes(selectionStartElement.type) &&
    isSelectionCollapsed &&
    isSelectionAtEndOfElement &&
    selectionStartTextNode.text.length === 0
  ) {
    Transforms.delete(editor, {at: selectionStartElementPath});
  }

  if (
    ['image', 'video'].includes(selectionStartElement.type) &&
    isSelectionCollapsed &&
    isSelectionAtEndOfElement &&
    selectionStartTextNode.text.length === 0
  ) {
    Transforms.delete(editor, {at: selectionStartElementPath});
    Transforms.insertNodes(editor, [makeParagraph()], {at: selectionStartElementPath});

    const startOfNewParagraph = {path: [...selectionStartElementPath, 0], offset: 0};
    requestAnimationFrame(() => {
      Transforms.setSelection(editor, {
        anchor: startOfNewParagraph,
        focus: startOfNewParagraph,
      });
    });

    return true;
  }

  // Had previously set it to select the process content from start to finish.
  // However, this led to buggy behavior where Slate would immediately deselect
  // everything if the process title had any content (!).
  // To avoid this, and as a reasonable alternative, we leave the selection at
  // the start of the next element. It's important that something is selected
  // or else key presses events won't do anything.
  const previousElementEnd = Editor.end(editor, [
    ...selectableElementPath.slice(0, -1),
    selectableElementPath.slice(-1)[0] - 1,
  ]);
  Transforms.setSelection(editor, {
    anchor: previousElementEnd,
    focus: previousElementEnd,
  });

  requestAnimationFrame(() => {
    selectElements([selectableElement.id]);
  });

  return true;
}

export default onDeleteOrShiftArrowBeforeSelectableElement;
